import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core";
import { PlainSelect } from "./PlainSelect";
import { WeekdaySelect } from "./WeekdaySelect";
import { HourSelect } from "./HourSelect";
import { MinuteSelect } from "./MinuteSelect";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
    },
    period: {
      margin: theme.spacing(1),
      minWidth: 60,
    },
    weekday: {
      margin: theme.spacing(1),
      minWidth: 60,
    },
    hour: {
      margin: theme.spacing(1),
      minWidth: 40,
    },
    minute: {
      margin: theme.spacing(1),
      minWidth: 40,
    },
  })
);

export interface ScheduleSelectData {
  uuid: string;
  period: string;
  date: string;
  weekday: string;
  hour: string;
  minute: string;
}

interface Props {
  data: ScheduleSelectData;
  groupId?: string | number | undefined;
  handlePeriodChange?:
    | ((
        event: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>,
        child: React.ReactNode,
        groupId?: string | number | undefined
      ) => void)
    | undefined;
  handleWeekdayChange?:
    | ((
        event: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>,
        child: React.ReactNode,
        groupId?: string | number | undefined
      ) => void)
    | undefined;
  handleHourChange?:
    | ((
        event: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>,
        child: React.ReactNode,
        groupId?: string | number | undefined
      ) => void)
    | undefined;
  handleMinuteChange?:
    | ((
        event: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>,
        child: React.ReactNode,
        groupId?: string | number | undefined
      ) => void)
    | undefined;
}

/** スケジュール選択 */
export function ScheduleSelect(props: Props) {
  const classes = useStyles();

  const {
    data,
    groupId,
    handlePeriodChange,
    handleWeekdayChange,
    handleHourChange,
    handleMinuteChange,
  } = props;

  const periodDefs = [
    {
      name: "毎日",
      value: "daily",
    },
    {
      name: "毎週",
      value: "weekly",
    },
  ];

  //--------------------
  // コンポーネント
  return (
    <div className={classes.container}>
      <div>
        <PlainSelect
          id="id_period"
          label="間隔"
          groupId={groupId}
          className={classes.period}
          defs={periodDefs}
          data={data.period}
          handleChange={handlePeriodChange}
        />
      </div>
      {data.period === "weekly" && (
        <div>
          <WeekdaySelect
            groupId={groupId}
            className={classes.weekday}
            data={data.weekday}
            handleChange={handleWeekdayChange}
          />
        </div>
      )}
      <div>
        <HourSelect
          groupId={groupId}
          className={classes.hour}
          data={data.hour}
          handleChange={handleHourChange}
        />
      </div>
      <div>
        <MinuteSelect
          groupId={groupId}
          className={classes.minute}
          data={data.minute}
          handleChange={handleMinuteChange}
        />
      </div>
    </div>
  );
}
